module.exports = "<div>\n    <div class=\"row message-container user-enable-disable-message\"\n         ng-class=\"{ 'success': (user.enableDisableStatus === 1 || user.enableDisableStatus === 2) }\"\n         ng-show=\"user.enableUserComplete === false && user.enableDisableMessage !== ''\">\n        <div class=\"col-md-12\">\n            <p>{{user.enableDisableMessage}}</p>\n        </div>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/accounts/user/personalInformation/personalInformationHeader.html
// module id = 357
// module chunks = 1